import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIndustry,
  faFire,
  faShieldAlt,
  faTruck,
  faAward,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import "./Home.css";

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Premium Firebricks Manufacturer</h1>
          <p>
            Leading manufacturer of high-quality firebricks for industrial and
            commercial applications
          </p>
          <div className="hero-buttons">
            <Link to="/products" className="btn btn-primary">
              Explore Products
            </Link>
            <Link to="/contact" className="btn btn-secondary">
              Get Connected
            </Link>
          </div>
        </div>
        <div className="hero-overlay"></div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2>Why Choose Ramkrishna Refractories?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={faIndustry} />
              </div>
              <h3>Advanced Manufacturing</h3>
              <p>
                State-of-the-art production facilities with cutting-edge
                technology for consistent quality.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={faFire} />
              </div>
              <h3>High Temperature Resistance</h3>
              <p>
                Our firebricks withstand extreme temperatures up to 1800°C for
                maximum durability.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={faShieldAlt} />
              </div>
              <h3>Quality Assurance</h3>
              <p>
                Rigorous testing and quality control processes ensure every
                product meets industry standards.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={faTruck} />
              </div>
              <h3>Reliable Delivery</h3>
              <p>
                Timely delivery across the country with proper packaging and
                handling.
              </p>
            </div>
            {/* <div className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={faAward} />
              </div>
              <h3>Industry Recognition</h3>
              <p>
                Certified by leading industry bodies and trusted by major
                industrial clients.
              </p>
            </div> */}
            <div className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <h3>Expert Support</h3>
              <p>
                Dedicated team of experts providing technical support and
                customized solutions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="about-preview">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>Recognized Firebricks Manufacturer</h2>
              <p>
                With over 50+ years of experience in the industry, Ramkrishna
                Refractories has established itself as a trusted name in
                firebricks manufacturing. We specialize in producing
                high-quality refractory materials that meet the demanding
                requirements of various industrial applications.
              </p>
              <p>
                Our commitment to innovation, quality, and customer satisfaction
                has made us the preferred choice for leading industries across
                the country.
              </p>
              <Link to="/about" className="btn btn-outline">
                Learn More About Us
              </Link>
            </div>
            <div className="about-image">
              <div className="image-placeholder">
                <FontAwesomeIcon icon={faIndustry} />
                <p>Manufacturing Excellence</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>
            Contact us today for a free consultation and quote on your
            firebricks requirements.
          </p>
          <Link to="/contact" className="btn btn-primary">
            Contact Us Now
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
